import React, { JSX, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SPAFramework from './Container/SPAFramework';
//import VideoClipperTestHarness from './Tests/VideoClipperTestHarness';
//import VideoTrimTestHarness from './Tests/VideoTrimTestHarness';
//import VideoUploaderTestHarness from './Tests/VideoUploaderTestHarness';
//import { ScrollDetacherTestHarness } from './Tests/ScrollDetacherTestHarness';
//import { FloatingCardSequenceTestHarness } from './Tests/FloatingCardSequenceTestHarness';
//import { RadioGroupTestHarness } from './Tests/RadioGroupTestHarness';
//import { ImageSelectorTestHarness } from './Tests/ImageSelectorTestHarness';
//import Mp4BoxTestHarness from './Tests/Mp4BoxTestHarness';
//import { ClipMakerTestHarness } from './Tests/ClipMakerTestHarness';
//import { RegionScrollerTestHarness } from './Tests/RegionScrollerTestHarness';
//import { VideoThumbnailBarTestHarness } from './Tests/VideoThumbnailBarTestHarness';
//import { NumberStepperTestHarness } from './Tests/NumberStepperTestHarness';
//import { SkitterbookControlsTestHarness } from './Tests/SkitterbookControlsTestHarness';
//import { CuttingProgressTestHarness } from './Tests/CuttingProgressTestHarness';
import { authFetch } from './Utils/FetchUtil';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './css/App.css';

function App(): JSX.Element {
    const [fontsLoaded, setFontsLoaded] = useState(false);

    useEffect(() => {
        document.fonts.ready.then((e) => {
            if (e.status === "loaded") {
                setFontsLoaded(true);
            }
        });
    }, []);

    useEffect(() => {
        const createSession = async () => {
            try {
                const response = await authFetch('/api/home/CreateSession', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                });

                if (!response.ok) {
                    throw new Error(`Session creation failed: ${response.status}`);
                }

                const sessionData = await response.json();
                console.log('Session created:', sessionData);
            } catch (error) {
                console.error('Error creating session:', error);
            }
        };

        createSession();
    }, []);

    const content = fontsLoaded ? (
        <BrowserRouter>
            <Routes>
                <Route path="/*" element={<SPAFramework />} />
            </Routes>
        </BrowserRouter>
    ) : (
        <div style={{ visibility: 'hidden' }} />
    );

    return content;
}

export default App;
